import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';


import { NotifyComponent  } from './notify.component';
import { NotifyService } from './notify.service';

@NgModule({
  imports: [
    FormsModule,
    MaterialModule,
  ],
  entryComponents: [
    NotifyComponent
  ],
  declarations: [
    NotifyComponent
  ],
  providers: [
    NotifyService
  ]
})
export class NotifyModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/notify/notify.module.ts